import { withOnClickTracking } from 'auto-tracking';
import { styled, theme } from 'design-system';
import { PropsWithChildren } from 'react';

import { useAuthContext } from '../auth-context';
import { Wiring } from '../pages/auth-page-utility';

const LinkButton = withOnClickTracking(
  styled('a', {
    color: theme.colors.blue9,
    cursor: 'pointer',
    marginLeft: '0.2rem',
  }),
);

export const EnhancedLinkButton = (
  props: PropsWithChildren<{
    emailValue?: string;
    onClick?: () => void;
    wiring: Wiring;
    tabIndex?: number;
  }>,
) => {
  const { authPageConfiguration } = useAuthContext();
  const button = (
    <LinkButton
      tabIndex={props.tabIndex}
      onClick={
        props.onClick || props.wiring.onClick
          ? () => {
              props.onClick?.();
              props.wiring.onClick?.();
            }
          : undefined
      }
      href={props.wiring.href}
    >
      {props.children}
    </LinkButton>
  );

  const linkWrapper = authPageConfiguration?.linkWrapper;
  if (props.wiring.href && linkWrapper) {
    return linkWrapper(props.wiring.href, button, props.emailValue);
  } else {
    return button;
  }
};
